/**
 * TanStack Query hooks for `drill-down-analytics`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	drillDownAnalyticsQueryKeys,
	type CreateDrillDownAnalyticsBody,
	type ListDrillDownAnalyticsResponse,
	type DrillDownAnalyticsRow,
} from "./api";

export function useDrillDownAnalyticsList(): UseQueryResult<ListDrillDownAnalyticsResponse, Error> {
	return useQuery({
		queryKey: drillDownAnalyticsQueryKeys.list(),
		queryFn: list,
	});
}

export function useDrillDownAnalyticsCreate(): UseMutationResult<DrillDownAnalyticsRow, Error, CreateDrillDownAnalyticsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: drillDownAnalyticsQueryKeys.all });
		},
	});
}

export function useDrillDownAnalyticsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: drillDownAnalyticsQueryKeys.all });
		},
	});
}
